<template>
    <div class="journey-events">
        <aside-content-header with-date-picker @dateChange="dateChange" :vehicle="currentJourney.vehicle" :is-hardware-online="isHardwareOnline"></aside-content-header>
        <div class="journey-events__content">
            <v-tabs
                v-model="activeTab"
                color="transparent"
                slider-color="#db1238"
                class="journey-events__tabs"
            >
                <v-tab
                    key="filter-events-tab"
                    class="journey-events__tab"
                    ripple
                >
                    Filter Events
                </v-tab>
                <v-tab
                    key="shared-events-tab"
                    class="journey-events__tab"
                    ripple
                >
                    Shared Events
                </v-tab>
                <v-tab-item
                    key="filter-events-tab"
                >
                    <div class="journey-events__subtitle">Event Classification</div>
                    <div class="journey-events__filter">
                        <v-select
                            v-model="filters.eventClassifications"
                            :items="availableEventClassification"
                            @change="isSelectChanged"
                            class="small-field"
                            label="Event classification"
                            item-value="id"
                            item-text="key"
                            placeholder="Select event classification..."
                            multiple
                            outline
                            clearable
                            single-line
                            hide-details
                        ></v-select>
                    </div>

                    <div class="journey-events__subtitle">Event Type</div>
                    <div class="journey-events__filter">
                        <v-select
                            v-model="filters.eventTypes"
                            :items="availableEventTypes"
                            class="small-field"
                            label="Event type"
                            item-value="id"
                            item-text="key"
                            placeholder="Select event type..."
                            multiple
                            outline
                            clearable
                            single-line
                            hide-details
                        ></v-select>
                    </div>

                    <div class="journey-events__subtitle">Event Category</div>
                    <div class="journey-events__filter">
                        <v-select
                            v-model="filters.eventCategories"
                            :items="availableEventCategory"
                            class="small-field"
                            label="Event category"
                            item-value="id"
                            item-text="key"
                            placeholder="Select event category..."
                            multiple
                            outline
                            clearable
                            single-line
                            hide-details
                        ></v-select>
                    </div>

                    <div class="loading" v-show="loading">
                        <div class="wrapper">
                            <v-progress-circular
                                indeterminate
                                color="rgba(255, 255, 255)"
                            ></v-progress-circular>
                            Loading...
                        </div>
                    </div>

                    <div id="events-list" class="journey-events__list" v-show="filteredEvents.length > 0">
                        <event-item
                            v-for="(event, index) in filteredFetchEvents"
                            :key="event.id"
                            :event="event"
                            :driverInfo="false"
                            :on-event-click="showEvent"
                        ></event-item>
                    </div>
                    <plug v-if="filteredEvents.length <= 0 && hasChosenFilters" icon="question" title="No events matching your filters" :width="45" :height="55" color="#e2e2e2"></plug>
                    <plug v-if="filteredEvents.length <= 0 && !hasChosenFilters" icon="question" title="No events have been found" :width="45" :height="55" color="#e2e2e2"></plug>
                </v-tab-item>
                <v-tab-item
                    key="shared-events-tab"
                >
                    <journey-shared-events-list :hardware-id="hardwareId"></journey-shared-events-list>
                </v-tab-item>
            </v-tabs>

        </div>
    </div>
</template>

<script>

import AsideContentHeader from '@/views/Tracking/components/Aside/AsideContentHeader/AsideContentHeader'
import Journeys from '@/models/Journeys'
import EventItem from '@/components/atoms/EventItem'
import Plug from '@/components/atoms/Plug'

import { mapGetters } from 'vuex'
import JourneySharedEventsList from '@/views/Tracking/components/Aside/JourneyEvents/JourneySharedEventsList'

export default {
    name: 'JourneyEvent',
    components: {
        JourneySharedEventsList,
        AsideContentHeader,
        EventItem,
        Plug
    },
    data () {
        return {
            filters: {
                eventClassifications: [],
                eventTypes: [],
                eventCategories: []
            },
            expanded: [true],
            filteredEvents: this.currentJourney.events,
            activeTab: 0,
            loading: true,
            perPage: 0,
            filteredFetchEvents: [],
            isDateChange: '',
            isSelectChange: false,
            isTypeCategory: false
        }
    },
    props: {
        currentJourney: {
            type: [Journeys, null],
            required: true
        },
        isHardwareOnline: {
            type: [Boolean],
            required: true
        },
        hardwareId: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            eventTypes: 'dictionaryModule/getEventTypes',
            eventClassifications: 'dictionaryModule/getEventClassifications',
            eventCategory: 'dictionaryModule/getEventCategories'
        }),
        availableEventTypes () {
            const availableCategories = [1, 2, 3, 5]
            return this.eventTypes.filter(event => availableCategories.includes(event.categoryId))
        },
        availableEventClassification () {
            const availableClassifications = [2, 3, 4]
            return this.eventClassifications.filter(event => availableClassifications.includes(event.id))
        },
        availableEventCategory () {
            const availableCategory = [1, 2, 3, 4, 5, 6]
            return this.eventCategory.filter(event => availableCategory.includes(event.id))
        },
        hasChosenFilters () {
            return (
                this.filters.eventCategories.length ||
                this.filters.eventTypes.length ||
                this.filters.eventClassifications.length
            )
        }
    },

    watch: {
        'filters': {
            handler (newFilters) {
                this.filterEvents(newFilters)
            },
            deep: true
        },
        'currentJourney.events': {
            handler (newEvents) {
                this.filteredEvents = newEvents
            }
        },
        perPage: {
            handler () {
                this.fetchEventsIntoScroll()
            },
            deep: true
        },
        isDateChange: {
            handler () {
                this.fetchEventsIntoScroll()
            },
            deep: true
        },
        isSelectChange: {
            handler () {
                this.fetchEventsIntoScroll()
            },
            deep: true
        }
    },
    mounted () {
        this.filteredFetchEvents.push(this.filteredEvents.slice(0, this.perPage))

        this.fetchEventsOnScroll()
    },
    methods: {
        fetchEventsIntoScroll () {
            this.loading = true

            if (this.perPage >= this.filteredFetchEvents.length) {
                this.filteredFetchEvents = []
                this.filteredFetchEvents.push(...this.filteredEvents.slice(0, this.perPage))
                this.isDateChange = false
                this.isSelectChange = false
            }

            if (this.filteredFetchEvents.length >= this.filteredEvents.length) {
                this.filteredFetchEvents = []
                this.filteredFetchEvents.push(...this.filteredEvents.slice(0, this.filteredEvents.length))
                this.isDateChange = false
                this.isSelectChange = false
                this.loading = false
            }

            setTimeout(() => {
                this.loading = false
            }, 500)
        },
        fetchEventsOnScroll () {
            const listElem = document.querySelector('#events-list')
            listElem.addEventListener('scroll', () => {
                if (listElem.scrollTop + listElem.clientHeight >= listElem.scrollHeight) {
                    this.loadMore()
                }
            })

            this.loadMore()
        },
        loadMore () {
            this.perPage = this.perPage + 25
        },
        filterEvents (newFilters) {
            this.filteredEvents = this.currentJourney.events.filter(event => {
                return (
                    (newFilters.eventClassifications.length ? newFilters.eventClassifications.some(evClass => event.eventClassification === evClass) : true) &&
                    (newFilters.eventTypes.length ? newFilters.eventTypes.some(evT => event.eventTypes.includes(evT)) : true) &&
                    (newFilters.eventCategories.length ? newFilters.eventCategories.some(evCat => event.eventCategories.includes(evCat)) : true)
                )
            })
        },
        showEvent (payload) {
            this.$store.commit('setEventId', payload)
        },
        isSelectChanged () {
            this.isSelectChange = true
        },
        dateChange () {
            this.isDateChange = true
        }
    }
}
</script>

<style scoped lang="scss">
.journey-events {
    &__content {
        padding: 10px 15px;

        ul {
            box-shadow: none;
            border-bottom: 1px solid #c1c1c1;
        }
    }

    &__title {
        font-weight: 700;
    }

    &__subtitle {
        font-size: 12px;
        font-weight: 700;
        padding: 10px 0 5px;
    }

    ::v-deep .v-text-field.v-text-field--placeholder input {
        margin-top: 0 !important;
    }

    &__filter {
        margin-bottom: 5px;
    }

    ::v-deep .journey-events__list .details .date {
        margin-right: 30px;
    }

    &__tab {
        text-transform: capitalize;
        font-weight: bold;
    }

    &__tabs {
        .v-tabs__container {
            content: '';
            height: 2px;
            width: 100%;
            background: gray;
            position: absolute;
            bottom: 0;
            z-index: 0;
        }
    }

    ::v-deep .mx-datepicker {
        input {
            height: 38px;
        }
    }

    &__list {
        position: relative;
        height: calc(100vh - 455px);
        overflow-y: scroll !important;
    }

    .loading {
        position: absolute;
        bottom: 0;
        z-index: 0;
        width: 100%;
        height: 450px;
        padding-top: 50%;
        text-align: center;
        background-color: #d2d2d2;
        opacity: 0.6;
    }
}
</style>
